module.exports = __webpack_public_path__ + "static/media/knock2.5dffb4c9.mp3";